/**
 * A delivered figure must match the ticket that authorised it (#1744 slice 5).
 *
 * Moved from `apps/portal/src/data.tsx` unchanged. It is a pure function over a
 * `Response` and a ticket — no client, no app state — so it belongs beside the
 * renderer that depends on the guarantee rather than in one host's query layer.
 */
/**
 * Refuse bytes whose delivered HTTP identity no longer matches the relay's
 * immutable verdict. Kept outside the hook so both mismatches can be mutation-
 * proved without mocking React Query or a browser session.
 */
export async function verifiedKbAssetBlob(
  res: Response,
  ticket: { content_type?: unknown; size_bytes?: unknown },
): Promise<Blob> {
  const expectedType = String(ticket.content_type ?? '').toLowerCase()
  const deliveredType = (res.headers.get('content-type') ?? '')
    .split(';', 1)[0]!.trim().toLowerCase()
  if (!expectedType || deliveredType !== expectedType) {
    throw new Error('that figure no longer matches its verified format')
  }

  const blob = await res.blob()
  const expectedSize = Number(ticket.size_bytes)
  if (!Number.isSafeInteger(expectedSize) || expectedSize < 0 || blob.size !== expectedSize) {
    throw new Error('that figure no longer matches its verified size')
  }
  return blob
}
